import { render, staticRenderFns } from "./BranchDteTemplateSettingsModal.vue?vue&type=template&id=ec309b18&scoped=true"
import script from "./BranchDteTemplateSettingsModal.vue?vue&type=script&lang=js"
export * from "./BranchDteTemplateSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./BranchDteTemplateSettingsModal.vue?vue&type=style&index=0&id=ec309b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec309b18",
  null
  
)

export default component.exports